/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { EntityType } from 'app/shared/model/enumerations/entity-type.model';

export interface IModuleLogo {
  id?: string;
  path?: string | null;
  entityType?: keyof typeof EntityType;
  entityId?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
}

export const defaultValue: Readonly<IModuleLogo> = {
  active: false,
};
